export default "__VITE_ASSET__D39Mf4hh__"